import { useState } from "react";
import { Link } from "react-router-dom";
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";
import InputField from "./components/inputField";


function PidRegistration(){
  return(
    <DashboardLayout> 
    <DashboardNavbar/>
     <InputField/>
   </DashboardLayout>

  )

} 
export default PidRegistration